export default {
  form: {
    amount: {
      label: 'Pris',
    },
    has_sales_based_discount: {
      label: 'Rabatter baseret på månedligt salg',
    },
  },
  labels: {
    month: 'måned',
    varies_by_tier: 'varierer efter niveau',
    max_price: '* Maksimumprisen er {{amount}}',
    sales_based_discount:
      'op til +{{threshold}} i mindstesalg på én måned. Derefter almindelig pris {{amount}} netto/måned',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (inkluderet)',
    exclusive: 'pr. måned plus {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Vælg',
    save: 'Gem',
    use_default_price: 'Brug standardpris',
  },
};
